import AgTechGridLink from '@agtech/web/components/Grids/Controls/AgTechGridLink'
import React from 'react'
import BidderLotsListPopUp from '../popups/BidderLotsListPopUp'

const BidderLotsListPopUpLink = (props: { bidderId: number, content: string, isClickable: boolean }) => {
    return (
        <AgTechGridLink
            content={props.content}
            onHover={props.isClickable ? () => ({
                popup: () => <BidderLotsListPopUp bidderId={props.bidderId} />,
                config: {
                    topOffset: 24,
                    shouldCloseOnBlur: false
                }
            }) : undefined}
            classes='px-2'
        />
    )
}

export default BidderLotsListPopUpLink